import {gql, useQuery} from '@apollo/client';
import {type QueryHookOptions} from '@apollo/client';

import type {
  GetReviewQueueQuery,
  GetReviewQueueQueryVariables,
} from '../types/graphql';
import {MESSAGE_CONTENT} from './fragments/MessageContent.gql';

/**
 * Query to fetch the review queue.
 */
export const GET_REVIEW_QUEUE = gql`
  ${MESSAGE_CONTENT}
  query GetReviewQueue($limit: Int!, $offset: Int!) {
    reviewQueue(limit: $limit, offset: $offset) {
      totalCount
      entries {
        id
        client {
          id
          fullName
        }
        needsReview
        markedForReviewTs
        markedForReviewReason
        lastReviewer {
          id
          fullName
        }
        lastMessage {
          ...MessageContent
        }
        lastReviewTs
      }
      hasNextPage
    }
  }
`;

/**
 * Hook to fetch the review queue.
 */
export const useGetReviewQueue = (
  opts?: QueryHookOptions<GetReviewQueueQuery, GetReviewQueueQueryVariables>,
) =>
  useQuery<GetReviewQueueQuery, GetReviewQueueQueryVariables>(
    GET_REVIEW_QUEUE,
    opts,
  );
